module.exports = __webpack_public_path__ + "img/slack-logo.715ff720.svg";